<template>
  <div>
    <CustomPageHeaderVue>{{ $t('nav_about') }}</CustomPageHeaderVue>
    <CustomRow>
      <v-card class="mt-5 cusPadding text-center" v-html="$t('about_content')">

      </v-card>
    </CustomRow>
  </div>
</template>

<script>
import CustomPageHeaderVue from '@/components/CustomPageHeader.vue';
export default {
  components: {
    CustomPageHeaderVue
  },
  metaInfo() {
    return {
      title: `${this.$t('nav_about')} - ${this.$t('app_name')}`,
      meta: [
        {
          property: 'og:title',
          content: `${this.$t('nav_about')} - ${this.$t('app_name')}`,
          vmid: 'og:title'
        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        }
      ],
      script: [{
        type: 'application/ld+json',
        json: {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": `${this.$t('nav_about')} - ${this.$t('app_name')}`,
          "url": window.location.href
        }
      }]
    }
  },
  mounted() {
    setTimeout(() => {
      this.$gtm.trackView(`About`, this.$route.path);
      this.$store.dispatch("setOverlayLoading", false);
    }, 200);
  },
}
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 55px;
  color: #444444;
}
</style>
